import { useEffect, useMemo, useRef, useState } from "react";
import { ArrowDownCircleIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import CommonModal from "../../common11/commonModals/CommonModal";
import EnhancedDynamicTablePagination from "../../common/CommonTable/EnhancedDynamicTablePagination";

// Reuse the same mock admission list data shape as AdmissionList / dashboard
export const getMockAdmissionList = () => [
  { admissionId: 100, status: "Admitted", uhid: "7760", patientName: "Mr Patient Three", contact: "9876543210", gender: "Male", age: "8", admDateTime: "11/06/2026 9:00 AM", doctorName: "Dr Mahesh Mandora", refDocName: "(Self)", wardName: "ICU I", bedNo: "3", tariffName: "HOSPITAL", admDate: "2026-06-11" },
  { admissionId: 1, status: "Admitted", uhid: "7758", patientName: "Mr Dhyanshwar Dhobale", contact: "7664385789", gender: "Male", age: "32", admDateTime: "06/02/2026 9:30 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance Apoll)", wardName: "Private Room", bedNo: "9", tariffName: "HOSPITAL", admDate: "2026-02-06" },
  { admissionId: 13, status: "Discharged", uhid: "7740", patientName: "Mr Ramesh Deshmukh", contact: "9988776654", gender: "Male", age: "48", admDateTime: "01/02/2026 8:00 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "General Ward", bedNo: "3", tariffName: "HOSPITAL", admDate: "2026-02-01" },
  { admissionId: 2, status: "Bill generated", uhid: "7753", patientName: "Mr Patient Two", contact: "9876543210", gender: "Female", age: "28", admDateTime: "05/02/2026 2:15 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "Private Room", bedNo: "12", tariffName: "HOSPITAL", admDate: "2026-02-05" },
  { admissionId: 14, status: "Discharged", uhid: "7739", patientName: "Mrs Lata Kulkarni", contact: "8877665543", gender: "Female", age: "52", admDateTime: "31/01/2026 2:30 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "Private Room", bedNo: "8", tariffName: "HOSPITAL", admDate: "2026-01-31" },
  { admissionId: 3, status: "Discharge initiated", uhid: "7750", patientName: "Mrs Priya Sharma", contact: "9988776655", gender: "Female", age: "45", admDateTime: "04/02/2026 11:00 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "General Ward", bedNo: "5", tariffName: "HOSPITAL", admDate: "2026-02-04" },
  { admissionId: 4, status: "Admitted", uhid: "7749", patientName: "Mr Rajesh Kumar", contact: "9123456789", gender: "Male", age: "55", admDateTime: "05/02/2026 3:45 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "ICU", bedNo: "2", tariffName: "HOSPITAL", admDate: "2026-02-05" },
  { admissionId: 5, status: "Bill generated", uhid: "7748", patientName: "Ms Anjali Desai", contact: "8765432109", gender: "Female", age: "29", admDateTime: "03/02/2026 8:20 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "Private Room", bedNo: "15", tariffName: "HOSPITAL", admDate: "2026-02-03" },
  { admissionId: 6, status: "Admitted", uhid: "7747", patientName: "Mr Suresh Patel", contact: "7654321098", gender: "Male", age: "62", admDateTime: "06/02/2026 10:15 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "General Ward", bedNo: "22", tariffName: "HOSPITAL", admDate: "2026-02-06" },
  { admissionId: 7, status: "Discharge initiated", uhid: "7746", patientName: "Mrs Meera Iyer", contact: "6543210987", gender: "Female", age: "38", admDateTime: "02/02/2026 4:00 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "Private Room", bedNo: "7", tariffName: "HOSPITAL", admDate: "2026-02-02" },
  { admissionId: 8, status: "Admitted", uhid: "7745", patientName: "Mr Vikram Singh", contact: "5432109876", gender: "Male", age: "41", admDateTime: "05/02/2026 1:30 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "General Ward", bedNo: "18", tariffName: "HOSPITAL", admDate: "2026-02-05" },
  { admissionId: 9, status: "Bill generated", uhid: "7744", patientName: "Ms Kavita Reddy", contact: "4321098765", gender: "Female", age: "33", admDateTime: "04/02/2026 9:00 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "Private Room", bedNo: "11", tariffName: "HOSPITAL", admDate: "2026-02-04" },
  { admissionId: 10, status: "Discharge initiated", uhid: "7743", patientName: "Mr Arun Nair", contact: "3210987654", gender: "Male", age: "50", admDateTime: "03/02/2026 2:30 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "General Ward", bedNo: "14", tariffName: "HOSPITAL", admDate: "2026-02-03" },
  { admissionId: 11, status: "Admitted", uhid: "7742", patientName: "Mrs Sunita Gupta", contact: "2109876543", gender: "Female", age: "58", admDateTime: "06/02/2026 7:45 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "ICU", bedNo: "1", tariffName: "HOSPITAL", admDate: "2026-02-06" },
  { admissionId: 12, status: "Bill generated", uhid: "7741", patientName: "Mr Deepak Joshi", contact: "1098765432", gender: "Male", age: "36", admDateTime: "05/02/2026 5:20 PM", doctorName: "Dr. Tukaram Aute", refDocName: "(Insurance)", wardName: "Private Room", bedNo: "20", tariffName: "HOSPITAL", admDate: "2026-02-05" },
  { admissionId: 15, status: "Discharged", uhid: "7738", patientName: "Mr Sanjay More", contact: "7766554432", gender: "Male", age: "61", admDateTime: "30/01/2026 10:45 AM", doctorName: "Dr. Tukaram Aute", refDocName: "(Self)", wardName: "ICU", bedNo: "4", tariffName: "HOSPITAL", admDate: "2026-01-30" },
];

const STATUS_BUTTONS = ["Admitted", "Discharged"];

const STATUS_STYLES = {
  Admitted: {
    selected: "bg-amber-500 text-white border-amber-500 shadow-sm",
    unselected: "bg-amber-100 text-amber-800 border-amber-300 hover:bg-amber-200",
  },
  Discharged: {
    selected: "bg-red-500 text-white border-red-500 shadow-sm",
    unselected: "bg-red-100 text-red-700 border-red-300 hover:bg-red-200",
  },
};

const matchesPatientSearch = (row, query) => {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    row.patientName,
    row.uhid,
    row.contact,
    row.regId,
    row.ipOpNumber,
    row.doctorName,
    row.wardName,
  ]
    .filter((v) => v != null && v !== "")
    .join(" ")
    .toLowerCase();
  return haystack.includes(q);
};

/** Compact table row height used to fit as many patients as possible in the modal. */
const COMPACT_ROW_PX = 34;
const TABLE_HEADER_PX = 40;
const MIN_ROWS_PER_PAGE = 8;

/**
 * Shared Admitted Patients picker used by OT Note, Dr Round, Discharge Summary, etc.
 * Filters: patient search + optional status tabs. No from/to date filters.
 */
function AdmittedPatientsModal({
  isOpen,
  onClose,
  onSelectPatient,
  onRowDoubleClick,
  rows,
  showStatusTabs = true,
  initialStatus = "Admitted",
}) {
  const [statusFilter, setStatusFilter] = useState(initialStatus);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [patientSearchText, setPatientSearchText] = useState("");
  const tableAreaRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setPatientSearchText("");
      setPage(0);
      setStatusFilter(initialStatus);
    }
  }, [isOpen, initialStatus]);

  // Fit page size to available table height so listing fills the modal.
  useEffect(() => {
    if (!isOpen) return undefined;

    const el = tableAreaRef.current;
    if (!el) return undefined;

    const updateRowsPerPage = () => {
      const height = el.clientHeight || 0;
      const usable = Math.max(0, height - TABLE_HEADER_PX - 8);
      const fit = Math.max(MIN_ROWS_PER_PAGE, Math.floor(usable / COMPACT_ROW_PX));
      setRowsPerPage((prev) => {
        if (prev !== fit) {
          queueMicrotask(() => setPage(0));
        }
        return fit;
      });
    };

    updateRowsPerPage();
    const observer = new ResizeObserver(updateRowsPerPage);
    observer.observe(el);
    return () => observer.disconnect();
  }, [isOpen]);

  const allRows = useMemo(
    () => (Array.isArray(rows) ? rows : getMockAdmissionList()),
    [rows]
  );

  const filteredData = useMemo(() => {
    return allRows.filter((row) => {
      if (showStatusTabs && row.status !== statusFilter) return false;
      return matchesPatientSearch(row, patientSearchText);
    });
  }, [allRows, statusFilter, showStatusTabs, patientSearchText]);

  const statusCounts = useMemo(() => {
    return STATUS_BUTTONS.reduce((acc, key) => {
      acc[key] = allRows.filter(
        (r) => r.status === key && matchesPatientSearch(r, patientSearchText)
      ).length;
      return acc;
    }, {});
  }, [allRows, patientSearchText]);

  const handleRowPick = (row) => {
    (onRowDoubleClick || onSelectPatient)?.(row);
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title="Admitted Patients"
      size="xl"
      maxHeightVh={96}
      disableScroll
      paperSx={{
        width: { xs: "calc(100vw - 12px)", sm: "96vw", lg: "min(98vw, 1480px)" },
        maxWidth: { lg: "min(98vw, 1480px)" },
        height: { xs: "92vh", lg: "90vh" },
        maxHeight: { xs: "92vh", lg: "90vh" },
        display: "flex",
        flexDirection: "column",
      }}
      disableBackdropClose={false}
      showCloseButton={true}
      actions={[]}
    >
      <div className="flex h-full min-h-0 flex-1 flex-col gap-3">
        <div className="relative w-full max-w-xl shrink-0">
          <MagnifyingGlassIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={patientSearchText}
            onChange={(e) => {
              setPatientSearchText(e.target.value);
              setPage(0);
            }}
            placeholder="Search by patient name / UHID / mobile no"
            className="w-full rounded-md border border-gray-300 bg-white py-2 pl-8 pr-3 text-sm text-gray-700 outline-none focus:border-[#217E90] focus:ring-1 focus:ring-[#217E90]"
          />
        </div>

        <div
          ref={tableAreaRef}
          className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm"
        >
          <EnhancedDynamicTablePagination
            dataResult={filteredData}
            setDataResult={() => {}}
            fetchData={() => {}}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            count={filteredData.length}
            removeHeaders={["admissionId", "regId", "doctorId", "isDischarged", "admDate"]}
            showPaginationBar={true}
            fillContainer
            renderActions={(row) => (
              <div className="flex items-center justify-center">
                <button
                  type="button"
                  onClick={() => handleRowPick(row)}
                  className="inline-flex items-center justify-center text-[#217E90] hover:text-[#1a5e70]"
                  title="Select patient"
                >
                  <ArrowDownCircleIcon className="h-4 w-4" />
                </button>
              </div>
            )}
            actionsPosition="start"
            renderCustomColumns={{}}
            stickyActions={true}
            stickyLeftColumns={showStatusTabs ? ["status", "uhid", "patientName"] : ["uhid", "patientName"]}
            highlightRow={true}
            customRowBgColor="#E9F5FE"
            customRowBorderColor="#217E90"
            tableHeading=""
            renderTableHeader={
              showStatusTabs
                ? () => (
                    <div className="flex flex-wrap items-center gap-2">
                      {STATUS_BUTTONS.map((status) => {
                        const style = STATUS_STYLES[status];
                        const isSelected = statusFilter === status;
                        const count = statusCounts[status] ?? 0;
                        return (
                          <button
                            key={status}
                            type="button"
                            className={`whitespace-nowrap px-3 py-1.5 text-xs rounded-md transition-all duration-200 flex-shrink-0 border font-medium ${
                              isSelected ? style.selected : style.unselected
                            }`}
                            onClick={() => {
                              setStatusFilter(status);
                              setPage(0);
                            }}
                          >
                            {status} ({count})
                          </button>
                        );
                      })}
                    </div>
                  )
                : undefined
            }
            onRowDoubleClick={handleRowPick}
          />
        </div>
      </div>
    </CommonModal>
  );
}

export default AdmittedPatientsModal;
